/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Clients_AddInputs */

const en_clients_add = /** @type {(inputs: Clients_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Add client`)
};

const pt_br2_clients_add = /** @type {(inputs: Clients_AddInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Adicionar cliente`)
};

/**
* | output |
* | --- |
* | "Add client" |
*
* @param {Clients_AddInputs} inputs
* @param {{ locale?: "en" | "pt-BR" }} options
* @returns {LocalizedString}
*/
export const clients_add = /** @type {((inputs?: Clients_AddInputs, options?: { locale?: "en" | "pt-BR" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Clients_AddInputs, { locale?: "en" | "pt-BR" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_clients_add(inputs)
	return pt_br2_clients_add(inputs)
});